import React from "react";
import {
  Landmark, Globe, Scale, TrendingUp, Leaf, Atom, HeartHandshake, Newspaper, BookOpen,
} from "lucide-react";

const ICONS = {
  landmark: Landmark, globe: Globe, scale: Scale, "trending-up": TrendingUp,
  leaf: Leaf, atom: Atom, "heart-handshake": HeartHandshake, newspaper: Newspaper,
  "book-open": BookOpen,
};

export default function SubjectIcon({ name, size = 22, color = "#1F3A68" }) {
  const Icon = ICONS[name] || BookOpen;
  return <Icon size={size} color={color} strokeWidth={1.8} />;
}
